import { type ReactElement } from 'react';
import styles from './loyalty-how-to-gain-points.module.scss';
import LoyaltyRuleView from '@utmb/types/view/LoyaltyRuleView';
import { RaceTableRules } from './race-table-rules/race-table-rules';
import { DonationTableRules } from './donation-table-rules copy/donation-table-rules';
import { LoyaltyActionEnum } from '@utmb/types/enum/LoyaltyActionEnum';
import { HowToGaminPointsSlice } from './points-slice/how-to-gain-points-slice';
import { LoyaltyAllActionEnum } from '@utmb/types/enum/LoyaltyAllActionEnum';
import { LoyaltyLevelEnum } from '@utmb/types/enum/LoyaltyLevelEnum';
import { useTranslation } from 'next-i18next';

export interface LoyaltyHowToGainPointProps {
    loyaltyRules: LoyaltyRuleView;
    currentLevel: LoyaltyLevelEnum;
}

export function LoyaltyHowToGainPoint({ loyaltyRules, currentLevel }: LoyaltyHowToGainPointProps): ReactElement | null {
    const { t } = useTranslation('myutmb');
    return (
        <div className={styles.loyaltyHowToGainPoint}>
            <div className={styles.wrapSlice}>
                <HowToGaminPointsSlice
                    action={LoyaltyAllActionEnum.PARTICIPATE_RACE_WS}
                    title={t(`myUtmb.howToGainPoints.title.${LoyaltyAllActionEnum.PARTICIPATE_RACE}`)}
                    description={t(`myUtmb.howToGainPoints.description.${LoyaltyAllActionEnum.PARTICIPATE_RACE}`)}
                >
                    <RaceTableRules
                        raceRules={loyaltyRules.participateRule}
                        indexCoef={loyaltyRules.coefRaceUtmbIndex}
                        wsCoef={loyaltyRules.coefRaceUtmbWorldSeries}
                    />
                </HowToGaminPointsSlice>
            </div>
            <div className={styles.wrapSlice}>
                <HowToGaminPointsSlice
                    action={LoyaltyAllActionEnum.FINISH_RACE}
                    title={t(`myUtmb.howToGainPoints.title.${LoyaltyAllActionEnum.FINISH_RACE}`)}
                    description={t(`myUtmb.howToGainPoints.description.${LoyaltyAllActionEnum.FINISH_RACE}`)}
                >
                    <RaceTableRules
                        raceRules={loyaltyRules.finisherRule}
                        indexCoef={loyaltyRules.coefRaceUtmbIndex}
                        wsCoef={loyaltyRules.coefRaceUtmbWorldSeries}
                    />
                </HowToGaminPointsSlice>
            </div>
            <div className={styles.wrapSlice}>
                <HowToGaminPointsSlice
                    action={LoyaltyAllActionEnum.DONATE_LEVEL1}
                    title={t(`myUtmb.howToGainPoints.title.DONATE`)}
                    description={t(`myUtmb.howToGainPoints.description.DONATE`)}
                >
                    <DonationTableRules
                        rules={loyaltyRules.actionRule.filter(
                            (target) =>
                                target.type === LoyaltyActionEnum.DONATE_LEVEL1 ||
                                target.type === LoyaltyActionEnum.DONATE_LEVEL2 ||
                                target.type === LoyaltyActionEnum.DONATE_LEVEL3
                        )}
                    />
                </HowToGaminPointsSlice>
            </div>

            <div className={styles.wrapSlice}>
                <HowToGaminPointsSlice
                    level={currentLevel}
                    action={LoyaltyAllActionEnum.SOLIDARITY_BIB}
                    title={t(`myUtmb.howToGainPoints.title.${LoyaltyAllActionEnum.SOLIDARITY_BIB}`)}
                    description={t(`myUtmb.howToGainPoints.description.${LoyaltyAllActionEnum.SOLIDARITY_BIB}`)}
                    quantity={loyaltyRules.actionRule.find((target) => target.type === LoyaltyActionEnum.SOLIDARITY_BIB)?.points}
                ></HowToGaminPointsSlice>
            </div>

            <div className={styles.wrapSlice}>
                <HowToGaminPointsSlice
                    level={currentLevel}
                    action={LoyaltyAllActionEnum.MOBILITY_TICKET}
                    title={t(`myUtmb.howToGainPoints.title.${LoyaltyAllActionEnum.MOBILITY_TICKET}`)}
                    description={t(`myUtmb.howToGainPoints.description.${LoyaltyAllActionEnum.MOBILITY_TICKET}`)}
                    quantity={loyaltyRules.actionRule.find((target) => target.type === LoyaltyActionEnum.MOBILITY_TICKET)?.points}
                ></HowToGaminPointsSlice>
            </div>

            <div className={styles.wrapSlice}>
                <HowToGaminPointsSlice
                    level={currentLevel}
                    action={LoyaltyAllActionEnum.CONTEST_WINNER}
                    title={t(`myUtmb.howToGainPoints.title.${LoyaltyAllActionEnum.CONTEST_WINNER}`)}
                    description={t(`myUtmb.howToGainPoints.description.${LoyaltyAllActionEnum.CONTEST_WINNER}`)}
                    quantity={loyaltyRules.actionRule.find((target) => target.type === LoyaltyActionEnum.CONTEST_WINNER)?.points}
                ></HowToGaminPointsSlice>
            </div>
        </div>
    );
}
